/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {
  TableDefault,
  ShadowTableColumn,
  StickyTableHead,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamAverageRow,
  ShadowSummaryColumn,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';

export default ({dataTableContent, dataCy}: {dataTableContent: Array<any>; dataCy?: string}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function handleNullOrCero(data) {
    return (data !== null || data !== undefined) ? data : '-';
  }
  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }
  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickyTableHead topPosition="141px" topPositionResponsive="41px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHead>
    );
  }

  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={2}>
            TOTAL EXAMS
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={5}>
            FRESH EXAMS
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={4}>
            POST EXAMS
          </StickyTableHead>
        </tr>
        <tr>
          <SortingTableHead title="Last 28 Days" attr="last28total" location={['total', 'last28Days']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Overall Total"
            attr="overalltotal"
            location={['total', 'overallTotal']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="Current" attr="freshcurrent" location={['fresh', 'current']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Next" attr="freshnext" location={['fresh', 'next']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Last 7 Days" attr="freshlast7days" location={['fresh', 'last7Days']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Last 28 Days"
            attr="freshlast28days"
            location={['fresh', 'last28Days']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="Total Fresh" attr="freshtotal" location={['fresh', 'total']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Current" attr="postcurrent" location={['post', 'current']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Last 7 Days" attr="postlast7days" location={['post', 'last7Days']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Last 28 Days"
            attr="postlast28days"
            location={['post', 'last28Days']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="Total Post" attr="posttotal" location={['post', 'total']} sortFunction={toggleSortNumber} />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table?.length > 0 ? (
          table?.map((item, index) => {
            if (index === 0) {
              return (
                <TeamAverageRow key={index}>
                  <td>{handleNullOrCero(item?.summary?.totalExamLast28Days)}</td>
                  <td>{handleNullOrCero(item?.summary?.overallTotal)}</td>
                  <ShadowSummaryColumn>{handleDate(item?.summary?.freshCurrent)}</ShadowSummaryColumn>
                  <ShadowSummaryColumn>{handleDate(item?.summary?.freshNext)}</ShadowSummaryColumn>
                  <ShadowSummaryColumn>{handleNullOrCero(item?.summary?.freshLast7Days)}</ShadowSummaryColumn>
                  <ShadowSummaryColumn>{handleNullOrCero(item?.summary?.freshLast28Days)}</ShadowSummaryColumn>
                  <ShadowSummaryColumn>{handleNullOrCero(item?.summary?.totalFresh)}</ShadowSummaryColumn>
                  <td>{handleDate(item?.summary?.postCurrent)}</td>
                  <td>{handleNullOrCero(item?.summary?.postLast7Days) || '-'}</td>
                  <td>{handleNullOrCero(item?.summary?.postLast28Days) || '-'}</td>
                  <td>{handleNullOrCero(item?.summary?.totalPost) || '-'}</td>
                </TeamAverageRow>
              );
            } else {
              return (
                <tr key={index}>
                  <td className="white">{handleNullOrCero(item?.summary?.totalExamLast28Days)}</td>
                  <td className="white">{handleNullOrCero(item?.summary?.overallTotal)}</td>
                  <ShadowTableColumn>{handleDate(item?.summary?.freshCurrent)}</ShadowTableColumn>
                  <ShadowTableColumn>{handleDate(item?.summary?.freshNext)}</ShadowTableColumn>
                  <ShadowTableColumn>{handleNullOrCero(item?.summary?.freshLast7Days)}</ShadowTableColumn>
                  <ShadowTableColumn>{handleNullOrCero(item?.summary?.freshLast28Days)}</ShadowTableColumn>
                  <ShadowTableColumn>{handleNullOrCero(item?.summary?.totalFresh)}</ShadowTableColumn>
                  <td className="white">{handleDate(item?.summary?.postCurrent)}</td>
                  <td className="white">{handleNullOrCero(item?.summary?.postLast7Days) || '-'}</td>
                  <td className="white">{handleNullOrCero(item?.summary?.postLast28Days) || '-'}</td>
                  <td className="white">{handleNullOrCero(item?.summary?.totalPost) || '-'}</td>
                </tr>
              );
            }
          })
        ) : (
          <tr>
            <td colSpan={11}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};
